<template>
    <div class="informasiPendaftaran">
        <SOSlotBase :container-name="`informasiPendaftaran`" :loading="isLoading">
            <template v-slot:title-bar>
                <SOTitleBar
                        :page-title="'Informasi Pendaftaran'"
                        :type="'back'"
                        @back="back"
                />
            </template>

            <template v-slot:content>
                <div class="d-flex-between-center container-cons">
                    <p class="m-d-0 f-c-midgrey f-12 f-regular">
                        Setelah transaksi berhasil, quota Training akan bertambah dan dapat
                        diakses di halaman Detail Training
                    </p>
                </div>

                <div class="p-x-20">
                    <template>
                        <div class="p-t-20">
                            <InfoUserTraining1
                                    :header="'Nama Program'"
                                    :value="detailJenisTraining.nama"
                            />
                            <InfoUserTraining1
                                    v-if="detailJenisTraining.id === 'free_online'"
                                    :header="'Jadwal Training'"
                                    :value="`${$moment(
                  formJadwal.jadwal_training[0].jadwal_mulai
                ).format('DD MMMM YYYY HH:mm')} - ${$moment(
                  formJadwal.jadwal_training[0].jadwal_selesai
                ).format('HH:mm')}`"
                            />
                            <InfoUserTraining1
                                    :header="'Nama Owner'"
                                    :value="formJadwal.nama_owner"
                            />
                            <InfoUserTraining1
                                    :header="'No Telephone'"
                                    :value="formJadwal.no_telp"
                            />
                        </div>
                    </template>
                    <div class="separator-line-dot p-d-8"></div>
                    <template v-if="detailJenisTraining.id !== 'free_online'">
                        <h3 id="Detail">Jadwal Training</h3>
                        <div class="p-x-20 p-y-16 bg-white">
                            <label class="f-regular f-16 f-c-midgrey remove-margin require"
                            >Pertemuan ke 1</label
                            >
                            <input
                                    type="text"
                                    class="form-control inputs"
                                    id="text_field"
                                    aria-describedby="emailHelp"
                                    :value="`${$moment(
                  formJadwal.jadwal_training[0].jadwal_mulai
                ).format('DD MMMM YYYY HH:mm')} - ${$moment(
                  formJadwal.jadwal_training[0].jadwal_selesai
                ).format('HH:mm')}`"
                                    readonly
                                    style="color: black; width: 100%"
                            />
                        </div>
                        <div
                                class="p-x-20 p-y-16 bg-white"
                                v-if="detailJenisTraining.id === 'paid_online'"
                        >
                            <label class="f-regular f-16 f-c-midgrey remove-margin require"
                            >Pertemuan ke 2</label
                            >
                            <input
                                    type="text"
                                    class="form-control inputs"
                                    id="text_field"
                                    aria-describedby="emailHelp"
                                    :value="`${$moment(
                  formJadwal.jadwal_training[1].jadwal_mulai
                ).format('DD MMMM YYYY HH:mm')} - ${$moment(
                  formJadwal.jadwal_training[1].jadwal_selesai
                ).format('HH:mm')}`"
                                    readonly
                                    style="color: black; width: 100%"
                            />
                        </div>
                    </template>
                    <SOButton
                            :primary="true"
                            :full="true"
                            :text="'Submit'"
                            :loading="isLoading"
                            :id="`submit-training`"
                            @action="handleButtonClick()"
                    />
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";
    import {moduleName} from "../store/state";
    import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
    import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
    import InfoUserTraining1 from "../components/InfoUserTraining1";
    import SOButton from "@/so-components/global/ui/SOButton";

    export default {
        name: "InformasiPendaftaran",
        components: {
            SOSlotBase,
            SOTitleBar,
            InfoUserTraining1,
            SOButton
        },
        data() {
            return {
                page: {
                    title: "Informasi Pendaftaran",
                    loading: false,
                    from: "training.add",
                },
            }
        },
        async mounted() {
            await this.init();
        },
        computed: {
            ...mapGetters(moduleName, {
                dataOwner: "detailOwner",
                detailJenisTraining: "detailJenisTraining",
                formJadwal: "formJadwal",
            }),
            isLoading() {
                return this.page.loading;
            },
        },
        methods: {
            ...mapActions({
                getDetailOwner: `${moduleName}/getDetailOwner`,
                getDetailJenisTraining: `${moduleName}/getDetailJenisTraining`,
                postDataTrainingCreate: `${moduleName}/postDataTrainingCreate`,
            }),
            back() {
                this.$router.go(-1);
            },
            setLoading(val) {
                this.page.loading = val;
            },

            async handleButtonClick() {
                this.setLoading(true);
                if (this.detailJenisTraining.id === "free_online") {
                    let data = {
                        id_jenis_training: this.formJadwal.id_jenis_training,
                        jadwal_training: [
                            {
                                jadwal_mulai: this.formJadwal.jadwal_training[0].jadwal_mulai,
                                jadwal_selesai: this.formJadwal.jadwal_training[0].jadwal_selesai,
                                sesi: this.formJadwal.jadwal_training[0].sesi,
                            },
                        ],
                        nama_owner: this.formJadwal.nama_owner,
                        no_telp: this.formJadwal.no_telp,
                        pembayaran: {
                            kode_promo: this.formJadwal.pembayaran.kode_promo,
                            akun: this.formJadwal.pembayaran.akun,
                            metode_pembayaran: this.formJadwal.pembayaran.metode_pembayaran,
                        },
                    };


                    const res = await this.postDataTrainingCreate(data).then((res) => {
                      this.setLoading(false);
                        if (!res.data) {
                            this.$toast.error(res);

                        } else {
                          if (res.data.code === 200) {
                            if (res.data.status) {

                              this.$toast.success(res.data.msg);
                              this.$router.push({
                                name: "pendaftaran.success",
                                params: {idtraining: res.data.data[0].id_training},
                              });
                            }
                          }

                            // this.setResponse(resulter.errorResult(msg));
                        }
                    }).catch((err) => {
                      alert(err)
                        this.setLoading(false);
                        this.$toast.error(err);
                        // this.setResponse(resulter.errorResult(e));
                    });
                } else {
                    this.$router.push({
                        name: "pembayaran.training",
                    });
                }
            },
            async init() {
                let params_idJenis = this.$route.params.idjenis;
                await this.getDetailOwner();
                await this.getDetailJenisTraining(params_idJenis);
            },
        },
    };
</script>

<style scoped>
    .container-cons .cons-logo {
        margin-right: 8px;
    }

    .container-cons {
        padding: 12px 20px;
        background-color: #f2f5f7;
        justify-content: unset;
    }

    @media (min-width: 320px) and (max-width: 424px) {
        #btn_Submit {
            margin-top: 100%;
        }
    }

    @media (min-width: 425px) and (max-width: 767px) {
        #btn_Submit {
            margin-top: 100%;
        }
    }

    @media (min-width: 768px) {
        #btn_Submit {
            margin-top: 90%;
        }
    }

    @media (min-width: 1024px) {
        #btn_Submit {
            margin-top: 34%;
        }
    }

    @media (min-width: 1440px) {
        #btn_Submit {
            margin-top: 32%;
        }
    }
</style>
